import {BsSearch,BsFillMoonStarsFill,BsSunFill} from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
const NavBar = ()=>{
    const location = useLocation();
    const dispatch = useDispatch();
    const mode = useSelector(state=>state.ModeReducer);

    const handleMode = ()=>{
        dispatch({type:'MODE'})
    }

    return <nav className='fixed top-0 right-0 left-0 z-20 bg-background dark:bg-background-dark md:flex flex-row justify-between lg:px-8 md:px-2 py-2 shadow-md hidden'>
        <Link className = 'text-headline dark:text-headline-dark lg:text-3xl text-xl font-heading tracking-wide' to={'/'}>{'<UNIQUE/>'}</Link>
        <section className= 'text-headline dark:text-headline-dark lg:text-lg md:text-sm md:px-4 font-heading tracking-wider flex flex-row justify-between items-center md:w-9/12 lg:w-7/12'>
            <Link to={'/'} className={`${(location.pathname==='/')?'border-b-2 border-b-tertiary-dark':null}`}>Home</Link>
            <Link to={'/Movies'} className={`${(location.pathname==='/Movies')?'border-b-2 border-b-tertiary-dark':null}`}>Movies</Link>
            <Link to={'/Tvshows'} className={`${(location.pathname==='/Tvshows')?'border-b-2 border-b-tertiary-dark':null}`}>Tv Shows</Link>
            <Link to={'/Intheaters'} className={`${(location.pathname==='/Intheaters')?'border-b-2 border-b-tertiary-dark':null}`}>In Theaters</Link>
            <Link to={'/Comingsoon'} className={`${(location.pathname==='/Comingsoon')?'border-b-2 border-b-tertiary-dark':null}`}>Coming Soon</Link>
            <Link to={'/Watchlist'} className={`${(location.pathname==='/Watchlist')?'border-b-2 border-b-tertiary-dark':null}`}>Watchlist</Link>
        </section>
        <section className='flex flex-row justify-between items-center lg:text-lg text-md font-heading text-headline dark:text-headline-dark'>
            <Link to="/Search" className='mr-2'>
                <BsSearch />
            </Link>
            <button onClick={handleMode}>
                {
                    (mode)?
                    <BsSunFill className='text-[orange]'/>
                    :
                    <BsFillMoonStarsFill/>
                }
            </button>
        </section>
    </nav>
}

export default NavBar;